import React from "react";
import { motion } from "framer-motion";

const Section = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const descriptionVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const arrowVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      className="hero"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.h1 variants={titleVariants}>Hello, I'm Steeb.</motion.h1>
      <motion.h2 variants={descriptionVariants}>
        A Software Engineer with a passion for modern web, startups,
        infrastructure and architecture. I love keeping on top of bleeding edge
        technology and enjoy working with people who are passionate about
        technology.
      </motion.h2>
      <motion.h3
        variants={arrowVariants}
        animate={{
          y: [0, 8, 0],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        style={{
          position: "relative",
          zIndex: 1,
        }}
      >
        ↓
      </motion.h3>
    </motion.div>
  );
};

export default Section;
